import { Attachment, AttType } from 'src/graphql/generated';
import { GPAFormData } from 'src/components/Pages/GPA/types';
import { prepareAttachments } from 'src/components/Attachments/utils';
import { useUploadAttachments } from 'src/hooks/useUploadAttachments';

export const useGpaAttachmentsUpload = () => {
  const uploadGpaFiles = useUploadAttachments(AttType.Groupattachments);
  const uploadGpaPCiles = useUploadAttachments(AttType.Grouppcattachments);
  const processAttachments = async (
    data: GPAFormData
  ): Promise<{
    aggregatedGpAttachments: Attachment[];
    aggregatedPcAttachments: Attachment[];
  }> => {
    // Separate new Files vs existing attachments
    const localGpaFiles = data.groupGPAttachments.filter((a): a is File => a instanceof File);

    const previousGpaAttachments = data.groupGPAttachments.filter(
      (a): a is Attachment => !(a instanceof File)
    );

    const localPcFiles = data.groupPCAttachments.filter((a): a is File => a instanceof File);

    const previousPcAttachments = data.groupPCAttachments.filter(
      (a): a is Attachment => !(a instanceof File)
    );

    try {
      // Upload in parallel
      const [newGpaAttachments, newPcAttachments] = await Promise.all([
        localGpaFiles.length ? uploadGpaFiles(localGpaFiles) : Promise.resolve([]),
        localPcFiles.length ? uploadGpaPCiles(localPcFiles) : Promise.resolve([])
      ]);

      return {
        aggregatedGpAttachments: [
          ...prepareAttachments(previousGpaAttachments),
          ...prepareAttachments(newGpaAttachments as Attachment[])
        ],
        aggregatedPcAttachments: [
          ...prepareAttachments(previousPcAttachments),
          ...prepareAttachments(newPcAttachments as Attachment[])
        ]
      };
    } catch (error) {
      throw error; // let component handle error
    }
  };

  return { processAttachments };
};
